module.exports = __webpack_public_path__ + "img/矩形 2941.50a65c50.png";